
import React from "react";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";

import DatePicker from "react-datepicker";
import Select from "react-select";

import SglContext from '../SglContext';
import './videos.css';
import "react-datepicker/dist/react-datepicker.css";

import Pagination from "../common/pagination";
import VideoPlayer from "./VideoPlayer";

import horse_logo from "../images/horse-logo.png";
import indicator_icon from "../images/Indicator.gif";
import download_image from "../images/download-video.png";
import play_video from "../images/play-video.png";
import play from "../images/play19.png";
import grid2_icon from "../images/grid_2.png";
import grid_icon from "../images/grid.png";
import list2_icon from "../images/list_2.png";
import list_icon from "../images/list.png";

// const sgl_webservice_videos_list = Sgl.nestApiUrl + "/videos";
// const sgl_webservice_videos = Sgl.sglApiUrl + '/iphonev2/videosv2/';
// const sgl_webservice_video_to_play = Sgl.nestApiUrl + "/videos/play/";

// TO CHANGE
let is_mobile = false;//is_mobile;
// TO CHANGE
var video_filters = JSON.parse(localStorage.getItem('video_filters'));
var filters_initial = {
    class_type: '',
    faults_op: '=',
    faults_query: '=',
    faults_value: '',
    faults_value2: '',
    placing_op: '=',
    placing_query: '=',
    placing_value: '',
    placing_value2: '',
    money_won: false,
    date_range:
    {
        start_date: '',
        end_date: ''
    },
    my_horses: '-1',
    my_shows: '-1',
    riders: '', // comma separated list of ids
    trainers: '', // comma separated list of ids
    owners: '', // comma separated list of ids
    horses: '',  // comma separated list of ids
}

const years = Array.from({ length: new Date().getFullYear() - 2015 + 1 }, (_, i) => 2015 + i)
const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

class Videos extends React.Component {

    get sgl_webservice_videos_list() {
        return this.context.nestApiUrl + '/videos';
    }

    get sgl_webservice_videos() {
        return this.context.sglApiUrl + '/iphonev2/videosv2/';
    }

    get sgl_webservice_video_to_play() {
        return this.context.nestApiUrl + '/videos/play/';
    }

    state = {
        filters: video_filters && video_filters.filters ? video_filters.filters : {},
        temp_filters: video_filters && video_filters.filters ? video_filters.filters : filters_initial,
        is_user_authorized: false,
        search_term: video_filters && video_filters.term ? video_filters.term : "",
        see_more: "",
        expand: "More",
        page: video_filters && video_filters.page ? video_filters.page : 1,
        total_rows: 0,
        videos_count: 0,
        selected_playlist: video_filters && video_filters.playlist ? video_filters.playlist : "0",
        videos_list: [],
        playlists: [],
        show_list: [],
        horse_list: [],
        hide_show_fault_input: video_filters && video_filters.filters && video_filters.filters.faults_query == '<>' ? true : false,
        hide_show_placing_input: video_filters && video_filters.filters && video_filters.filters.placing_query == '<>' ? true : false,

        start_date: video_filters && video_filters.filters && video_filters.filters.date_range && video_filters.filters.date_range.start_date ? video_filters.filters.date_range.start_date : '',
        end_date: video_filters && video_filters.filters && video_filters.filters.date_range && video_filters.filters.date_range.end_date ? video_filters.filters.date_range.end_date : '',
        start_date_obj: video_filters && video_filters.filters && video_filters.filters.date_range && video_filters.filters.date_range.start_date ? new Date(video_filters.filters.date_range.start_date) : '',
        end_date_obj: video_filters && video_filters.filters && video_filters.filters.date_range && video_filters.filters.date_range.end_date ? new Date(video_filters.filters.date_range.end_date) : '',

        is_mobile: false,
        timeout: null,

        my_shows: '-1',

        search_people_list: video_filters && video_filters.filters && video_filters.filters.riders_obj ? video_filters.filters.riders_obj : [],
        search_horses_list: video_filters && video_filters.filters && video_filters.filters.horses_obj ? video_filters.filters.horses_obj : [],
        search_owner_list: video_filters && video_filters.filters && video_filters.filters.owners_obj ? video_filters.filters.owners_obj : [],
        search_trainer_list: video_filters && video_filters.filters && video_filters.filters.trainers_obj ? video_filters.filters.trainers_obj : [],

        isLoadingRider: false,
        isLoadingTrainer: false,
        isLoadingOwner: false,
        isLoadingHorse: false,

        selectedRiderTags: video_filters && video_filters.filters && video_filters.filters.riders ? video_filters.filters.riders : [],
        selectedTrainerTags: video_filters && video_filters.filters && video_filters.filters.trainers ? video_filters.filters.trainers : [],
        selectedOwnerTags: video_filters && video_filters.filters && video_filters.filters.owners ? video_filters.filters.owners : [],
        selectedHorseTags: video_filters && video_filters.filters && video_filters.filters.horses ? video_filters.filters.horses : [],

        selectedOptionRider: video_filters && video_filters.filters && video_filters.filters.riders_obj ? video_filters.filters.riders_obj : [],
        selectedOptionTrainer: video_filters && video_filters.filters && video_filters.filters.trainers_obj ? video_filters.filters.trainers_obj : [],
        selectedOptionHorse: video_filters && video_filters.filters && video_filters.filters.horses_obj ? video_filters.filters.horses_obj : [],
        selectedOptionOwner: video_filters && video_filters.filters && video_filters.filters.owners_obj ? video_filters.filters.owners_obj : [],

        filter_applied: video_filters && video_filters.filters && video_filters.filters.filter_applied ? video_filters.filters.filter_applied : false,

        loading: true,
        userData: {},
        login_people_id: -1,
        is_admin: false,

        gridView: true,
        is_open_play_video_modal: false,
        play_video_path: '',
        video_to_play: {},
        playing_preview: false,

        is_open_get_video_url: false,
        is_open_report_problem_modal: false,
        is_open_add_to_playlist_modal: false,
        is_open_do_subscription_modal: false,
        is_download_subscription: false,

        selected_payment_method: '-1',
        payment_agree: false,
        selected_show: 0,
        selected_circuit: '-1',

        // Refs
        PaginationElement: React.createRef(),

        // Waits
        search_wait: false,
        search_term_wait: false,
        playlist_wait: false,
        pagination_wait: false,

        // Filter form show
        show_advanced_filters_form: video_filters && video_filters.filters && video_filters.filters.filter_applied ? video_filters.filters.filter_applied : false,

        goToSubscribe: false,
        ip_address: '',
    };

    constructor(props) {
        super(props);

        // bind function in constructor instead of render
        this.onChangePage = this.onChangePage.bind(this);
        this.handleChangeSearchTerm = this.handleChangeSearchTerm.bind(this);
        this.hideForm = this.hideForm.bind(this);
        this.hideInput = this.hideInput.bind(this);
        this.renderDatePicker = this.renderDatePicker.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.getPeopleSearchData = this.getPeopleSearchData.bind(this);
        this.getHorseSearchData = this.getHorseSearchData.bind(this);
        this.handleChangeRider = this.handleChangeRider.bind(this);
        this.handleInputChangeRider = this.handleInputChangeRider.bind(this);
        this.handleChangeTrainer = this.handleChangeTrainer.bind(this);
        this.handleInputChangeTrainer = this.handleInputChangeTrainer.bind(this);
        this.handleChangeOwner = this.handleChangeOwner.bind(this);
        this.handleInputChangeOwner = this.handleInputChangeOwner.bind(this);
        this.handleChangeHorse = this.handleChangeHorse.bind(this);
        this.handleInputChangeHorse = this.handleInputChangeHorse.bind(this);
        this.setStateOfSearchedList = this.setStateOfSearchedList.bind(this);
        this.setNameOfPeople = this.setNameOfPeople.bind(this);
        this.displayLoaderInSelect = this.displayLoaderInSelect.bind(this);
        this.hideLoaderInSelect = this.hideLoaderInSelect.bind(this);

        this.openPlayVideoModal = this.openPlayVideoModal.bind(this);
        this.closePlayVideoModal = this.closePlayVideoModal.bind(this);

        this.closeSubscriptionModal = this.closeSubscriptionModal.bind(this);
        this.openSubscriptionModal = this.openSubscriptionModal.bind(this);
        this.playVideoAfterSubscribe = this.playVideoAfterSubscribe.bind(this);

        this.renderCustomHeader = this.renderCustomHeader.bind(this);
        this.renderSubscribeNavigator = this.renderSubscribeNavigator.bind(this);
    }

    getBrowserInfo() {
        var sBrowser;
        var sUsrAg = window.navigator.userAgent;

        // The order matters here, and this may report false positives for unlisted browsers.

        if (sUsrAg.indexOf("Firefox") > -1) {
            sBrowser = "Mozilla Firefox";
            // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
        } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
            sBrowser = "Samsung Internet";
            // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
        } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
            sBrowser = "Opera";
            // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
        } else if (sUsrAg.indexOf("Trident") > -1) {
            sBrowser = "Microsoft Internet Explorer";
            // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
        } else if (sUsrAg.indexOf("Edge") > -1) {
            sBrowser = "Microsoft Edge";
            // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
        } else if (sUsrAg.indexOf("Chrome") > -1) {
            sBrowser = "Google Chrome or Chromium";
            // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
        } else if (sUsrAg.indexOf("Safari") > -1) {
            sBrowser = "Apple Safari";
            // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
        } else {
            sBrowser = "unknown";
        }
        return sBrowser;
    }

    fetchFile(video) {
        var vid = video.videos_sgl_id;
        return this.sgl_webservice_videos + 'Download?vid=' + vid + '&customer_id=' + this.context.company_id;

    }

    componentDidMount() {
        document.title = 'Videos';
        this.getAllData(
            this.state.page,
            this.state.search_term,
            this.state.selected_playlist,
            this.state.filters
        );
        


        if (is_mobile == 1) {
            this.setState({
                is_mobile: is_mobile,
            });
        }
    }

    getVideosData(page, term, playlist, filters, people_id) {
        var filters_obj = {
            'page': page,
            'term': term,
            'playlist': playlist,
            'filters': filters
        }
        if(Object.keys(filters).length != 0){
            if(filters.date_range){
                if(filters.date_range.start_date ==="1970-1-1"){
                    filters.date_range.start_date =""
                }
                if(filters.date_range.end_date ==="1970-1-1"){
                    filters.date_range.end_date =""
                }
            }
            
        }

        this.setState({ page: page })
        localStorage.setItem('video_filters', JSON.stringify(filters_obj));
        axios.get(this.sgl_webservice_videos_list, {
            params: {
                playlist: playlist,
                page: page,
                search_text: term,
                advance_search: filters,
                people_id: people_id,
                customer_id: this.context.company_id,
            },
        })
       
            .then((res) => {

                if (res.data.is_user_authorized) {
                    this.context.checkLoginOnSGL()
                }

                this.context.reportToGA('/sgl-wp-plugin/' + this.context.company_urlpath + '/videos/list/page/' + page);
                this.context.reportToFB('/sgl-wp-plugin/' + this.context.company_urlpath + '/videos/list/page/' + page);
                this.setState({
                    is_user_authorized: res.data.is_user_authorized,
                    playlists: res.data.playlists,
                    show_list: res.data.show_list,
                    horse_list: res.data.horse_list,
                    videos_data: res.data.videos,
                    videos_list: res.data.videos.videos_list,
                    page: res.data.page,
                    total_rows: res.data.videos.total_videos,
                    videos_count: res.data.videos.videos_count,
                    loading: false,
                    search_wait: false,
                    pagination_wait: false,
                    search_term_wait: false,
                    playlist_wait: false,
                });
                if (this.state.filter_applied) {
                    this.setState({ filter_applied: false, show_advanced_filters_form: true });
                }

                if (res.data.is_user_authorized && localStorage.getItem('playing_video_id') && localStorage.getItem('playing_video_url') == window.location.pathname.replace(this.context.basePath, '') + window.location.search) {
                    var video_to_play = res.data.videos.videos_list.find(c => (c.videos_sgl_id == localStorage.getItem('playing_video_id')));
                    this.playVideo('', video_to_play, false);
                }

                if (res.data.is_user_authorized && localStorage.getItem('download_video_id')) {
                    var video_to_download = res.data.videos.videos_list.find(c => (c.videos_sgl_id == localStorage.getItem('download_video_id')));
                    if (video_to_download) {
                        if (video_to_download.video_downloadable) {
                            window.open(
                                this.fetchFile(video_to_download),
                                '_blank' // <- This is what makes it open in a new window.
                            );
                        } else {
                            this.purchaseDownload(video_to_download);
                        }
                    }
                    localStorage.removeItem('download_video_id')
                }
            });
    }

    getAllData(page, term, playlist, filters) {
        this.getUserData(page, term, playlist, filters);

    }
    getUserData(page, term, playlist, filters) {
        this.context.getUser()

        if (this.context.current_user && this.context.current_user != null) {
            this.setState({
                userData: this.context.current_user,
                login_people_id: this.context.current_user.sgl_id
            });
            this.getVideosData(page, term, playlist, filters, this.context.current_user.sgl_id);
        } else {
            this.getVideosData(page, term, playlist, filters, -1);
        }
    }

    handleChangeRider = (selectedOptionRider) => {
        let tempList = [];
        selectedOptionRider.map((option) => {
            tempList.push(option.people_id);
        });
        this.setState({
            selectedOptionRider,
            selectedRiderTags: tempList,
        });
    };

    handleInputChangeRider = (characterEntered) => {
        this.getPeopleSearchData(characterEntered, "rider");
    };

    handleChangeTrainer = (selectedOptionTrainer) => {
        let tempList = [];
        selectedOptionTrainer.map((option) => {
            tempList.push(option.people_id);
        });
        this.setState({
            selectedOptionTrainer,
            selectedTrainerTags: tempList,
        });
    };

    handleInputChangeTrainer = (characterEntered) => {
        this.getPeopleSearchData(characterEntered, "trainer");
    };

    handleChangeOwner = (selectedOptionOwner) => {
        let tempList = [];
        selectedOptionOwner.map((option) => {
            tempList.push(option.people_id);
        });
        this.setState({
            selectedOptionOwner,
            selectedOwnerTags: tempList,
        });
    };

    handleInputChangeOwner = (characterEntered) => {
        this.getPeopleSearchData(characterEntered, "owner");
    };

    handleChangeHorse = (selectedOptionHorse) => {
        let tempList = [];
        selectedOptionHorse.map((option) => {
            tempList.push(option.horse_id);
        });
        this.setState({
            selectedOptionHorse,
            selectedHorseTags: tempList,
        });
    };

    handleInputChangeHorse = (characterEntered) => {
        this.getHorseSearchData(characterEntered);
    };

    getPeopleSearchData(keyword, field) {
        if (keyword !== "" && keyword.length >= 3) {
            this.displayLoaderInSelect(field);
            axios.get(this.sgl_webservice_videos_list + "/peopleSearch", {
                params: {
                    keyword: keyword,
                    field: field,
                    customer_id: this.context.company_id,
                },
            }).then((res) => {
                let governing_organization = res.data.governing_organization;
                res.data.people_list.forEach((rider) => {
                    rider["label"] = this.setNameOfPeople(
                        rider,
                        governing_organization
                    );
                    rider["value"] = rider["people_id"];
                });
                this.setStateOfSearchedList(res.data.people_list, field);
                this.hideLoaderInSelect(field);
            });
        }
    }

    displayLoaderInSelect(field) {
        if (field == "rider") {
            this.setState({ isLoadingRider: true });
        } else if (field == "owner") {
            this.setState({ isLoadingOwner: true });
        } else if (field == "trainer") {
            this.setState({ isLoadingTrainer: true });
        } else if (field == "horse") {
            this.setState({ isLoadingHorse: true });
        }
    }

    hideLoaderInSelect(field) {
        if (field == "rider") {
            this.setState({ isLoadingRider: false });
        } else if (field == "owner") {
            this.setState({ isLoadingOwner: false });
        } else if (field == "trainer") {
            this.setState({ isLoadingTrainer: false });
        } else if (field == "horse") {
            this.setState({ isLoadingHorse: false });
        }
    }

    setNameOfPeople(person, governing_organization) {
        let governing_organization_number, final_name;
        if (governing_organization == "EC") {
            governing_organization_number = person.ec_sln;
        } else if (governing_organization == "FEI") {
            governing_organization_number = person.fei_id;
        } else {
            governing_organization_number = person.usef_no;
        }

        final_name = person.fl_name.length > 0 ? person.fl_name : person.lf_name;
        if (governing_organization_number !== "") {
            final_name +=
                " - " + governing_organization + ": " + governing_organization_number;
        }
        return final_name;
    }

    setStateOfSearchedList(list, field) {
        if (field == "rider") {
            this.setState({ search_people_list: list });
        } else if (field == "trainer") {
            this.setState({ search_trainer_list: list });
        } else if (field == "owner") {
            this.setState({ search_owner_list: list });
        }
    }

    getHorseSearchData(keyword) {
        if (keyword !== "" && keyword.length >= 3) {
            this.setState({
                isLoadingHorse: true,
            });
            axios
                .get(this.sgl_webservice_videos_list + "/horseSearch", {
                    params: {
                        keyword: keyword,
                        customer_id: this.context.company_id,
                    },
                })
                .then((res) => {
                    res.data.horses_list.forEach((rider) => {
                        rider["value"] = rider["horse_id"];
                        rider["label"] = rider["name"];
                    });
                    this.setState({
                        search_horses_list: res.data.horses_list,
                        isLoadingHorse: false,
                    });
                });
        }
    }

    onChangePage(page) {
        this.setState({ pagination_wait: true })

        this.getVideosData(
            page,
            this.state.search_term,
            this.state.selected_playlist,
            this.state.filters,
            this.state.userData.sgl_id
        );
    }

    handleChangeSearchTerm(event) {
        this.setState({ search_term: event.target.value })
        if (this.state.timeout) {
            clearTimeout(this.state.timeout);
        }
        event.persist();
        this.state.timeout = setTimeout(() => {
            this.setState({ search_term_wait: true })
            this.getVideosData(
                1,
                event.target.value,
                this.state.selected_playlist,
                this.state.filters,
                this.state.userData.sgl_id
            );
        }, 700);
    }

    hideForm(event) {
        let do_expand = false
        event.preventDefault();
        this.state.see_more = this.state.see_more == "" ? true : false;
        if (this.state.expand == "More") {
            do_expand = true
            this.state.expand = "Less";
        } else if ((this.state.expand = "Less")) {
            this.state.expand = "More";
        }
        this.setState({
            see_more: this.state.see_more,
            show_advanced_filters_form: do_expand,
        });
    }

    changeVideosView(view) {
        this.state.gridView = view == "grid" ? true : false;
        if (view == "list") {
            document.getElementById("list").className = "sgl-button";
            document.getElementById("grid").className = " sgl-button-opp";
        } else {
            document.getElementById("list").className = " sgl-button-opp";
            document.getElementById("grid").className = " sgl-button";
        }
        this.setState({
            gridView: this.state.gridView,
        });
    }

    hideInput(event) {
        let hideShowInput = event.target.value == "<>" ? true : false;
        if (event.target.id == "faults_op") {
            this.setState({
                hide_show_fault_input: hideShowInput,
            });
        } else {
            this.setState({
                hide_show_placing_input: hideShowInput,
            });
        }
    }

    format_placing(placing) {
        if (placing > 0) {
            var i = placing % 10;
            var place = placing.toString().substring(placing.length - 2);

            if (i == 1 && place != "11") {
                return placing + "st";
            } else if (i == 2 && place != "12") {
                return placing + "nd";
            } else if (i == 3 && place != "13") {
                return placing + "rd";
            }
            return placing + "th";
        } else {
            return "-";
        }
    }

    getFaults(video) {
        var video_faults = "";
        if (video.classes_class_type == "Jumpers") {
            var faults_one =
                video.entryxclasses_time_fault_one + video.entryxclasses_faults_one;
            var faults_two =
                video.entryxclasses_time_fault_two + video.entryxclasses_faults_two;

            if (video.entryxclasses_disqualify_status_one) {
                video_faults = "R1: " + video.entryxclasses_disqualify_status_one;
            } else if (video.entryxclasses_time_one > 0) {
                video_faults =
                    "R1: " +
                    faults_one +
                    "/" +
                    video.entryxclasses_time_one +
                    "s";
            } else {
                video_faults = "R1: N/A";
            }

            if (video.entryxclasses_disqualify_status_two) {
                video_faults += " - JO: " + video.entryxclasses_disqualify_status_two;
            } else if (video.entryxclasses_time_two > 0) {
                video_faults +=
                    " - JO:" +
                    faults_two +
                    "/" +
                    video.entryxclasses_time_two +
                    "s";
            } else {
                video_faults += "";
            }
        } else if (
            video.classes_class_type == "Hunters" ||
            video.classes_class_type == "Equitation"
        ) {
            // getting sum or avg of non-zero score values
            var score_array = [
                video.entryxclasses_scoreone,
                video.entryxclasses_scoretwo,
                video.entryxclasses_scorethree,
                video.entryxclasses_scorefour,
                video.entryxclasses_scorefive,
                video.entryxclasses_scoresix,
            ];
            var non_zero_nums = score_array.filter(
                (item) => isFinite(item) && item !== 0
            );
            var score = 0;
            if (non_zero_nums.length > 0) {
                score = non_zero_nums.reduce((a, b) => a + b, 0);
                // if(hunter_scoreby == "Average Score"){
                //     score = score/non_zero_nums.length;
                // }
            }

            if (score > 0) {
                video_faults = "Score: " + Number(score.toFixed(3));
            } else {
                video_faults = "Score: N/A";
            }
        }

        return video_faults;
    }

    getVideoPlayerFaults(video) {
        var video_faults = "";
        if (video.classes_class_type == "Jumpers") {
            var faults_one =
                video.entryxclasses_time_fault_one + video.entryxclasses_faults_one;
            var faults_two =
                video.entryxclasses_time_fault_two + video.entryxclasses_faults_two;

            if (video.videos_trip_type.toString().toLowerCase() == 'jo') {
                // $faults = $trip->time_fault_two + $trip->faults_two;
                video_faults = ' - Jump Off';
                if (video.entryxclasses_time_two > 0) {
                    video_faults += " with " + faults_two + " faults in " + video.entryxclasses_time_two + " secs.";
                } else if (faults_two > 0) {
                    video_faults += " with {$faults} faults.";
                }
            } else {
                // $faults = $trip->time_fault_one + $trip->faults_one;
                video_faults += ' - Round 1';
                if (video.entryxclasses_time_one > 0) {
                    video_faults += " with " + faults_one + " faults in " + video.entryxclasses_time_one + " secs.";
                } else if (faults_one > 0) {
                    video_faults += " with " + faults_one + " faults.";
                }
            }


        } else if (video.classes_class_type == "Hunters") {
            // getting sum or avg of non-zero score values
            var score_array = [
                video.entryxclasses_scoreone,
                video.entryxclasses_scoretwo,
                video.entryxclasses_scorethree,
                video.entryxclasses_scorefour,
                video.entryxclasses_scorefive,
                video.entryxclasses_scoresix,
            ];
            var non_zero_nums = score_array.filter(
                (item) => isFinite(item) && item !== 0
            );
            var score = 0;
            if (non_zero_nums.length > 0) {
                score = non_zero_nums.reduce((a, b) => a + b, 0);
                // if(hunter_scoreby == "Average Score"){
                //     score = score/non_zero_nums.length;
                // }
            }

            if (score > 0) {
                video_faults = " with " + score + " score.";
            }
        }

        return video_faults;
    }
    format_currancy(amount) {
        return (
            "$" + (amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
        );
    }
    format_date(unformatted_date) {
        var month = new Array();
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sep";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";
        var unformatted_date_split = (unformatted_date && unformatted_date.split) ? unformatted_date.split('T')[0] : unformatted_date;
        var formatted_date = new Date(unformatted_date_split);
        formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
        formatted_date.getUTCMonth();
        return (
            month[formatted_date.getMonth()] +
            " " +
            formatted_date.getDate() +
            "," +
            formatted_date.getFullYear()
        );
    }

    format_time(timeString) {
        var H = +timeString.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = H < 12 || H === 24 ? " AM" : " PM";
        timeString = h + timeString.substr(2, 3) + ampm;
        return timeString;
    }

    onPlaylistSelect(e) {
        this.setState({
            selected_playlist: e.target.value,
            playlist_wait: true,
        });
        if (!this.state.is_user_authorized && e.target.value == "-1") {
            window.location.href = process.env.REACT_APP_LOGIN_PAGE_URL;
        }
        this.getVideosData(
            1,
            this.state.search_term,
            e.target.value,
            this.state.filters,
            this.state.userData.sgl_id
        );
    }


    handleStartDateChange = (date, event) => {
        let dates = new Date(date)
        let dateStr = dates.getFullYear() + '-' + (dates.getMonth() + 1) + '-' + dates.getDate();
        this.setState({
            start_date: dateStr,
            start_date_obj: date            
        });
    };
    handleEndDateChange = (date, event) => {

        let dates = new Date(date)
        let dateStr = dates.getFullYear() + '-' + (dates.getMonth() + 1) + '-' + dates.getDate();
        this.setState({
            end_date:dateStr,
            end_date_obj: date 
        });
    };

    renderDatePicker = () => {
        if (this.context.is_mobile) {
            return (
                <input
                    type="date"
                    id="start_date"
                    name="start_date"
                    value={this.state.start_date}
                    onChange={this.handleStartDateChange}
                />
            );
        }
        return (
            <DatePicker
                // isClearable
                id="start_date"
                name="start_date"
                renderCustomHeader={this.renderCustomHeader}
                dateFormat={"yyyy-MM-dd"}
                // value={this.state.start_date}
                selected={this.state.start_date_obj}
                onChange={this.handleStartDateChange}

                
            />
        );
    };

    renderCustomHeader = (date) => {
        return (
            <div
                style={{
                    margin: 10,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <select
                    value={date.date.getFullYear()}
                    onChange={({ target: { value } }) => date.changeYear(value)}
                >
                    {years.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>

                <select
                    value={months[date.date.getMonth()]}
                    onChange={({ target: { value } }) =>
                        date.changeMonth(months.indexOf(value))
                    }
                >
                    {months.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>
        )
    }

    renderEndDatePicker = () => {
        if (this.context.is_mobile) {
            return (
                <input
                    type="date"
                    id="end_date"
                    name="end_date"
                    value={this.state.end_date}
                    onChange={this.handleEndDateChange}
                />
            );
        }
        return (
            <DatePicker
                // isClearable
                id="end_date"
                name="end_date"
                renderCustomHeader={this.renderCustomHeader}
                // value={this.state.end_date}
                dateFormat={"yyyy-MM-dd"}
                selected={this.state.end_date_obj}
                onChange={this.handleEndDateChange}
            />
            
        );
    };

    onFilterSelect(e, field) {
        if (field == 'faults_query' || field == 'placing_query') {
            this.hideInput(e)
        }
        var temp_filters_data = this.state.temp_filters;
        if (field == 'money_won') {
            temp_filters_data[field] = e.target.checked;
        } else {
            temp_filters_data[field] = e.target.value;
        }
        this.setState({
            temp_filters: temp_filters_data
        });

        // this.setState(prevState => {
        //   let filter = Object.assign({}, prevState.temp_filters);  // creating copy of state variable jasper
        //   filter[field] = value;                     // update the name property, assign a new value                 
        //   return { filter };                                 // return new object jasper object
        // })
        // this.setState({
        //   my_shows: e.target.value,
        // });
    }

    applyFilters = () => {
        this.setState({ search_wait: true })
        let class_type = document.getElementById("class_type");
        let my_horses = document.getElementById("my_horses");
        let faults_op = document.getElementById("faults_op");
        let faults_val = document.getElementById("faults_val");
        let faults_val_sec = document.getElementById("faults_val_sec");
        let placing_op = document.getElementById("placing_op");
        let placing_val = document.getElementById("placing_val");
        let placing_val_sec = document.getElementById("placing_val_sec");
        let my_shows = document.getElementById("my_shows");
        let money_won_yes = document.getElementById("money_won_yes");

        var filters_obj = {};
        var filter_applied = false;
        if (class_type.value != "") {
            filters_obj.class_type = class_type.value;
            filter_applied = true;
        }
        if (my_horses.value != "-1") {
            filters_obj.my_horses = my_horses.value;
            filter_applied = true;
        }
        filters_obj.faults_query = faults_op.value;
        if (faults_op.value == "<>") {
            if (faults_val.value != "" || faults_val_sec.value != "") {
                filters_obj.faults_value = faults_val.value;
                filters_obj.faults_value2 = faults_val_sec.value;
                filter_applied = true;
            }
        } else {
            if (faults_val.value != "") {
                filters_obj.faults_value = faults_val.value;
                filter_applied = true;
            }
        }

        filters_obj.placing_query = placing_op.value;
        if (placing_op.value == "<>") {
            if (placing_val.value != "" || placing_val_sec.value != "") {
                filters_obj.placing_value = placing_val.value;
                filters_obj.placing_value2 = placing_val_sec.value;
                filter_applied = true;
            }
        } else {
            if (placing_val.value != "") {
                filters_obj.placing_value = placing_val.value;
                filter_applied = true;
            }
        }
        if (my_shows.value != "-1") {
            filters_obj.my_shows = my_shows.value;
            filter_applied = true;
        }
        if (money_won_yes.checked == true) {
            filters_obj.money_won = true;
            filter_applied = true;
        }
        if (this.state.start_date || this.state.end_date) {
            var date_obj = {};
            if (this.state.start_date) {
                date_obj.start_date = this.state.start_date;
                filter_applied = true;
            }
            if (this.state.end_date) {
                date_obj.end_date = this.state.end_date;
                filter_applied = true;
            }
            filters_obj.date_range = date_obj;
        }

        if (this.state.selectedRiderTags.length > 0) {
            filters_obj.riders = this.state.selectedRiderTags;
            filters_obj.riders_obj = this.state.selectedOptionRider;
            filter_applied = true;
        }
        if (this.state.selectedTrainerTags.length > 0) {
            filters_obj.trainers = this.state.selectedTrainerTags;
            filters_obj.trainers_obj = this.state.selectedOptionTrainer;
            filter_applied = true;
        }
        if (this.state.selectedOwnerTags.length > 0) {
            filters_obj.owners = this.state.selectedOwnerTags;
            filters_obj.owners_obj = this.state.selectedOptionOwner;
            filter_applied = true;
        }
        if (this.state.selectedHorseTags.length > 0) {
            filters_obj.horses = this.state.selectedHorseTags;
            filters_obj.horses_obj = this.state.selectedOptionHorse;
            filter_applied = true;
        }
        filters_obj.filter_applied = filter_applied;

        this.setState({
            filters: filters_obj,
            page: 1,
        });

        this.getVideosData(
            1,
            this.state.search_term,
            this.state.selected_playlist,
            filters_obj,
            this.state.userData.sgl_id
        );
    };
    clearFilters = () => {
        let search = document.getElementById("search");
        let class_type = document.getElementById("class_type");
        let my_horses = document.getElementById("my_horses");
        let faults_op = document.getElementById("faults_op");
        let faults_val = document.getElementById("faults_val");
        let faults_val_sec = document.getElementById("faults_val_sec");
        let placing_op = document.getElementById("placing_op");
        let placing_val = document.getElementById("placing_val");
        let placing_val_sec = document.getElementById("placing_val_sec");
        let my_shows = document.getElementById("my_shows");
        let money_won_yes = document.getElementById("money_won_yes");
        // let start = document.getElementById("start_date");
        // let end = document.getElementById("end_date");

        search.value = "";
        // start.value = "";
        // end.value ="";
        class_type.value = "";
        my_horses.value = "-1";
        faults_op.value = "=";
        faults_val.value = "";
        // faults_val_sec.value = '';
        placing_op.value = "=";
        placing_val.value = "";
        // placing_val_sec.value = '';
        my_shows.value = "-1";
        money_won_yes.checked = false;
        this.setState({
            temp_filters: filters_initial,
            filters: {},
            start_date: "",
            end_date: "",
            hide_show_fault_input: false,
            hide_show_placing_input: false,
            search_term: "",
            selected_playlist: 0,
            end_date_obj: "",
            start_date_obj: "",
            search_people_list: [],
            search_horses_list: [],
            search_owner_list: [],
            search_trainer_list: [],
            selectedRiderTags: [],
            selectedTrainerTags: [],
            selectedOwnerTags: [],
            selectedHorseTags: [],
            selectedOptionRider: [],
            selectedOptionTrainer: [],
            selectedOptionHorse: [],
            selectedOptionOwner: [],
            show_advanced_filters_form: false
        });
        localStorage.removeItem('video_filters');

        this.getVideosData(
            1,
            "",
            0,
            {},
            this.state.userData.sgl_id
        );
    };

    renderSubscribeNavigator() {
        let go = this.state.goToSubscribe
        if (go) {
            this.setState({ goToSubscribe: false })
            return (<Navigate to={'/videos/subscribe?sub=1'} />)
        }
        return null;
    }

    ///////// video player functions ///////////
    getVideoDetailUrl(video) {
        var video_url = '/videos/detail?vid=' + video.videos_sgl_id;

        return video_url;
    }

    playVideo(video_path, video_to_play, is_preview) {
        this.setState({ playing_preview: is_preview });
        if (is_preview) {
            this.setState({ play_video_path: video_path, video_to_play: video_to_play });
            this.openPlayVideoModal();
        } else {
            this.playVideoAPICall(video_to_play.videos_sgl_id);
        }
    }
    playVideoAPICall(video_id) {
        localStorage.setItem('playing_video_id', video_id);
        localStorage.setItem('playing_video_url', window.location.pathname.replace(this.context.basePath, '') + window.location.search);
        axios.get(this.sgl_webservice_video_to_play + video_id, {
            params: {
                customer_id: this.context.company_id
            }
        })
            .then((res) => {
                this.closeSubscriptionModal();
                localStorage.removeItem("playing_video_id");
                localStorage.removeItem("playing_video_url");
                if (res.data.subscribed_to_play) {
                    this.setState({
                        video_to_play: res.data.video,
                        is_open_play_video_modal: true,
                        playing_video: true,
                        is_admin: res.data.is_admin
                    })
                } else {
                    this.setState({
                        video_to_play: res.data.video,
                        is_admin: res.data.is_admin,
                        is_open_do_subscription_modal: true,
                        playing_video: true
                    })
                }
            });
    }
    openPlayVideoModal() {
        this.setState({
            is_open_play_video_modal: true,
        });

    }

    closePlayVideoModal() {
        this.setState({
            is_open_play_video_modal: false,
        });
    }


    //////// subscription functions ////////////
    openSubscriptionModal() {
        this.setState({
            is_open_do_subscription_modal: true,
        });
    }
    closeSubscriptionModal() {
        localStorage.removeItem("download_video_id");
        this.setState({
            is_open_do_subscription_modal: false,
            is_download_subscription: false,
        });
    }
    playVideoAfterSubscribe() {
        if (this.state.is_download_subscription) {
            localStorage.removeItem('download_video_id');
            this.closeSubscriptionModal();
            this.getVideosData(
                this.state.page,
                this.state.search_term,
                this.state.selected_playlist,
                this.state.filters,
                this.state.userData.sgl_id
            );
            window.open(
                this.fetchFile(this.state.video_to_play),
                '_blank' // <- This is what makes it open in a new window.
            );
            // call download function here
        } else {
            this.playVideoAPICall(this.state.video_to_play.videos_sgl_id);
            this.getVideosData(
                this.state.page,
                this.state.search_term,
                this.state.selected_playlist,
                this.state.filters,
                this.state.userData.sgl_id
            );
        }
    }
    purchaseDownload(video_to_play) {

        localStorage.setItem('download_video_id', video_to_play.videos_sgl_id);
        this.setState({ is_download_subscription: true, video_to_play: video_to_play })
        this.openSubscriptionModal();
    }
    //////// end subscription functions ////////////

    render() {
        const loading = this.state.loading;
        if (loading) {
            return null;
        }
        return (
            <div className="sgl-plugin videos-css">
                <style>{'.sgl-plugin-page .credit-text {float: left;}'}</style>
                {this.renderSubscribeNavigator()}
                <div className='align-buttons'>
                    <h1>Videos</h1>
                    <button className='right sgl-button sub_button' onClick={() => this.setState({ goToSubscribe: true })}>Subscribe</button>
                </div>
                <div className="formDiv">
                    <form className="flex-container">
                        <div className="my-row">
                            <div className="sw-30 input-group">
                                <label className="" htmlFor="search">
                                    Search:
                                    {this.state.search_term_wait ? <span id="search-term-wait" className=''>  <img src={indicator_icon} /></span> : null}
                                </label>
                                <input
                                    type="text"
                                    value={this.state.search_term}
                                    onChange={this.handleChangeSearchTerm}
                                    id="search"
                                />
                            </div>
                            <div className="playlist-div">
                                <div className="set-width">
                                    <label htmlFor="select_playlist">Playlist:
                                        {this.state.playlist_wait ? <span id="playlist-wait" className=''>   <img src={indicator_icon} /></span> : null}
                                    </label>
                                    <select
                                        id="select_playlist"
                                        value={this.state.selected_playlist}
                                        onChange={(e) => this.onPlaylistSelect(e)}
                                    >
                                        <option value="0">All Videos</option>
                                        <option value="-1">My Subscribed Videos</option>

                                        {this.state.is_user_authorized ? (
                                            this.state.playlists.map((playlist, index) => {
                                                return (
                                                    <option key={playlist.sgl_id} value={`${playlist.sgl_id}`}>
                                                        {playlist.name}
                                                    </option>
                                                );
                                            })
                                        ) : (
                                            <option value="-1">Log in to View Your Playlist</option>
                                        )}
                                    </select>
                                </div>

                                <div className="list-grid set-width-list-grid">
                                    <button
                                        className="sgl-button-opp"
                                        id="list"
                                        value="list"
                                        type="button"
                                        onClick={() => this.changeVideosView("list")}
                                    >
                                        <img className='list-grid-img' src={this.state.gridView ? list2_icon : list_icon} value="list" /> <span value="list">List</span>
                                    </button>
                                    <button
                                        className="sgl-button"
                                        id="grid"
                                        value="grid"
                                        type="button"
                                        onClick={() => this.changeVideosView("grid")}
                                    >
                                        <img className='list-grid-img' src={this.state.gridView ? grid_icon : grid2_icon} value="grid" /><span value="grid"> Grid</span>
                                    </button>
                                </div>

                                <div>
                                    <button className="expand-style" onClick={this.hideForm}>
                                        More Filters
                                    </button>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.show_advanced_filters_form ?
                                <div id="advanced_filters_form" className="">
                                    <div className="my-row">
                                        <div className="input-group">
                                            <label className="" htmlFor="class_type">
                                                Class Type
                                            </label>
                                            <select id="class_type"
                                                value={this.state.temp_filters.class_type}
                                                onChange={(e) => this.onFilterSelect(e, 'class_type')}
                                            >
                                                <option value="" selected="selected">
                                                    -- Select Type --
                                                </option>
                                                <option value="Jumpers">Jumpers</option>
                                                <option value="Hunters">Hunters</option>
                                                <option value="Dressage">Dressage</option>
                                                <option value="Equitation">Equitation</option>
                                            </select>
                                        </div>

                                        <div className="input-group">
                                            <label className="">My Horses</label>
                                            <select
                                                name="my_horses"
                                                id="my_horses"
                                                className="donotreplace select-default"
                                                value={this.state.temp_filters.my_horses}
                                                onChange={(e) => this.onFilterSelect(e, 'my_horses')}
                                            >
                                                <option value="-1">-- Select Horse --</option>
                                                {this.state.horse_list.map((horse, index) => {
                                                    return (
                                                        <option value={`${horse.horse_id}`}>
                                                            {horse.name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="my-row">
                                        <div className="input-group">
                                            <label className="" htmlFor="class_type">
                                                Faults
                                            </label>
                                            <div className="fault-placing-style">
                                                <select
                                                    name="faults_op"
                                                    id="faults_op"
                                                    className="set-width-80p donotreplace select-default"
                                                    value={this.state.temp_filters.faults_query}
                                                    onChange={(e) => this.onFilterSelect(e, 'faults_query')}
                                                >
                                                    <option value="=" >
                                                        Equals to
                                                    </option>
                                                    <option value="<>">Between</option>
                                                    <option value="<">Less than</option>
                                                    <option value="<=">Less than or equal to</option>
                                                    <option value=">">Greater than</option>
                                                    <option value=">=">Greater than or equal to</option>
                                                </select>
                                                <input
                                                    type="text"
                                                    className="set-width-10p margin-style"
                                                    name="faults_val"
                                                    id="faults_val"
                                                    maxlength="4"
                                                    value={this.state.temp_filters.faults_value}
                                                    onChange={evt => this.onFilterSelect(evt, 'faults_value')}
                                                />
                                                {this.state.hide_show_fault_input && (
                                                    <input
                                                        type="text"
                                                        className="set-width-10p margin-style"
                                                        name="faults_val_sec"
                                                        id="faults_val_sec"
                                                        maxlength="4"
                                                        value={this.state.temp_filters.faults_value2}
                                                        onChange={(e) => this.onFilterSelect(e, 'faults_value2')}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                        <div className="input-group">
                                            <label className="" htmlFor="class_type">
                                                Placing
                                            </label>
                                            <div className="fault-placing-style">
                                                <select
                                                    name="placing_op"
                                                    id="placing_op"
                                                    className="set-width-80p donotreplace select-default"
                                                    value={this.state.temp_filters.placing_query}
                                                    onChange={(e) => this.onFilterSelect(e, 'placing_query')}
                                                >
                                                    <option value="=" selected="selected">
                                                        Equals to
                                                    </option>
                                                    <option value="<>">Between</option>
                                                    <option value="<">Less than</option>
                                                    <option value="<=">Less than or equal to</option>
                                                    <option value=">">Greater than</option>
                                                    <option value=">=">Greater than or equal to</option>
                                                </select>
                                                <input
                                                    className="set-width-10p margin-style"
                                                    type="text"
                                                    name="placing_val"
                                                    id="placing_val"
                                                    maxlength="3"
                                                    value={this.state.temp_filters.placing_value}
                                                    onChange={(e) => this.onFilterSelect(e, 'placing_value')}
                                                />
                                                {this.state.hide_show_placing_input && (
                                                    <input
                                                        className="set-width-10p margin-style"
                                                        type="text"
                                                        name="placing_val_sec"
                                                        id="placing_val_sec"
                                                        maxlength="3"
                                                        value={this.state.temp_filters.placing_value2}
                                                        onChange={(e) => this.onFilterSelect(e, 'placing_value2')}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="my-row">
                                        <div className="input-group">
                                            <label className="">Start Date</label>
                                            {this.renderDatePicker()}
                                        </div>

                                        <div className="input-group">
                                            <label className="">End Date</label>
                                            {this.renderEndDatePicker()}
                                        </div>
                                    </div>

                                    <div className="my-row">
                                        <div className="input-group">
                                            <label className="">Shows</label>
                                            <select
                                                name="my_shows"
                                                id="my_shows"
                                                className="donotreplace showlist"
                                                value={this.state.temp_filters.my_shows}
                                                onChange={(e) => this.onFilterSelect(e, 'my_shows')}


                                            // value={this.state.filter_show}
                                            >
                                                <option value="-1">-- Select Show --</option>
                                                {this.state.show_list.map((show, index) => {
                                                    return (
                                                        <option value={`${show.show_id}`}>
                                                            {show.show_name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="pad-top-ig input-group">
                                            <input
                                                className="checkbox-class"
                                                type="checkbox"
                                                name="money_won_yes"
                                                id="money_won_yes"
                                                checked={this.state.temp_filters.money_won}
                                                onChange={(e) => this.onFilterSelect(e, 'money_won')}
                                            />
                                            <label className="style-checkbox">Prize Money Won?</label>
                                        </div>
                                    </div>
                                    <br />
                                    <h2>Advanced Search</h2>
                                    <div className="my-column">
                                        <div className="as-input-group">
                                            <label className="set-width-as-4">Riders</label>
                                            <Select
                                                className="set-width-100p"
                                                name="rider"
                                                value={this.state.selectedOptionRider}
                                                isMulti
                                                joinValues={true}
                                                searchable={true}
                                                onChange={this.handleChangeRider}
                                                onInputChange={this.handleInputChangeRider}
                                                isLoading={this.state.isLoadingRider}
                                                options={this.state.search_people_list}
                                            />
                                        </div>

                                        <div className="as-input-group">
                                            <label className="set-width-as-4">Trainers</label>
                                            <Select
                                                className="set-width-100p"
                                                name="trainer"
                                                value={this.state.selectedOptionTrainer}
                                                isMulti
                                                joinValues={true}
                                                searchable={true}
                                                onChange={this.handleChangeTrainer}
                                                onInputChange={this.handleInputChangeTrainer}
                                                isLoading={this.state.isLoadingTrainer}
                                                options={this.state.search_trainer_list}
                                            />
                                        </div>

                                        <div className="as-input-group">
                                            <label className="set-width-as-4">Owners</label>
                                            <Select
                                                className="set-width-100p"
                                                name="owner"
                                                value={this.state.selectedOptionOwner}
                                                isMulti
                                                joinValues={true}
                                                searchable={true}
                                                onChange={this.handleChangeOwner}
                                                onInputChange={this.handleInputChangeOwner}
                                                isLoading={this.state.isLoadingOwner}
                                                options={this.state.search_owner_list}
                                            />
                                        </div>

                                        <div className="as-input-group">
                                            <label className="set-width-as-4">Horses</label>
                                            <Select
                                                className="set-width-100p"
                                                name="horse"
                                                value={this.state.selectedOptionHorse}
                                                isMulti
                                                joinValues={true}
                                                searchable={true}
                                                onChange={this.handleChangeHorse}
                                                onInputChange={this.handleInputChangeHorse}
                                                isLoading={this.state.isLoadingHorse}
                                                options={this.state.search_horses_list}
                                            />
                                        </div>
                                    </div>

                                    <div className="my-row-end">
                                        {this.state.search_wait ? <span id="search-wait" className=''><img src={indicator_icon} /></span> : null}
                                        <input
                                            type="button"
                                            id="apply_filter"
                                            className="button"
                                            name="apply_filter"
                                            value="Search"
                                            onClick={this.applyFilters}
                                        />
                                        <input
                                            type="button"
                                            id="clear"
                                            className="button"
                                            name="clear"
                                            value="Clear"
                                            onClick={this.clearFilters}
                                        />
                                    </div>
                                </div> : null
                        }
                    </form>
                </div>

                <div
                    id="videos_listing"
                    className={this.state.gridView ? "grid" : "list"}
                >
                    <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
                    <div className="flex-video-container">

                        {this.state.total_rows > 0 ? (
                            this.state.videos_list.map((video, index) => {
                                return (
                                    <div key={video.videos_sgl_id} className="video_container ">
                                        <div className="video-content">

                                            <div className="thumb-image">
                                                <img id="thumbnail" src={(video.thumb_url && video.thumb_url != '') ? video.thumb_url : horse_logo} />
                                                {video.subscribed_to_play ? (
                                                    <span className="play-video-strip green cursor-pointer">
                                                        <img src={play_video} /> Play Video
                                                    </span>
                                                ) : (
                                                    <span className="play-video-strip orange cursor-pointer">
                                                        <img src={play_video} /> Subscribe
                                                    </span>
                                                )}
                                                <a onClick={() => this.playVideo(video.video_url, video, false)} className="play-wrapper">
                                                    <span className="play-button">
                                                        <span className="play">
                                                            <img src={play} />
                                                        </span>
                                                    </span>
                                                </a>
                                                {video.preview_url && (
                                                    <span className="preview-strip cursor-pointer" onClick={() => this.playVideo(video.preview_url, video, true)}>
                                                        <img src={play_video} /> Preview
                                                    </span>
                                                )}
                                            </div>
                                            <div className="video_details">
                                                {video.videos_related_table == "entryxclasses" ? (
                                                    <div>
                                                        <a onClick={() => this.playVideo(video.video_url, video, false)} className='cursor-pointer'>
                                                            <strong className="link_color">
                                                                {video.entries_number +
                                                                    " - " +
                                                                    video.entries_horse}
                                                            </strong>
                                                            {video.entryxclasses_placing > 0 && (
                                                                <span
                                                                    className={
                                                                        "place_" +
                                                                        video.entryxclasses_placing +
                                                                        " placing"
                                                                    }
                                                                >
                                                                    {this.format_placing(
                                                                        video.entryxclasses_placing
                                                                    )}
                                                                </span>
                                                            )}
                                                            <br />
                                                            <span className="link_color">
                                                                {video.entryxclasses_rider_name}
                                                            </span>
                                                            <br />
                                                            <span className="link_color">
                                                                {video.classes_number +
                                                                    " - " +
                                                                    video.classes_name +
                                                                    " (" +
                                                                    video.videos_trip_type.toUpperCase() +
                                                                    ")"}{" "}
                                                            </span>
                                                            <br />
                                                            <span className="link_color">
                                                                {this.getFaults(video)}
                                                            </span>
                                                            {video.entryxclasses_placing > 0 && (
                                                                <span className={"link_color placing"}>
                                                                    {video.entryxclasses_total_prize_money == "0.00"
                                                                        ? ""
                                                                        : this.format_currancy(
                                                                            video.entryxclasses_total_prize_money
                                                                        )}
                                                                </span>
                                                            )}
                                                            <br />
                                                            <span className="link_color">
                                                                {video.show_tables_show_name}
                                                            </span>
                                                            <br />
                                                            <span className="grey_text">
                                                                {this.format_date(video.classes_scheduled_date) +
                                                                    " - " +
                                                                    this.format_time(
                                                                        video.entryxclasses_actual_go_time
                                                                    )}
                                                            </span>
                                                            <br />
                                                        </a>
                                                    </div>

                                                ) : (
                                                    <div>
                                                        <span className="link_color">
                                                            {video.classes_number +
                                                                " - " +
                                                                video.classes_name}
                                                        </span>
                                                    </div>
                                                )}
                                                {video.videos_hidden != 0 && (
                                                    <span className="required">[HIDDEN]</span>
                                                )}
                                                {
                                                    (
                                                        <div>
                                                            {video.video_downloadable > 0 && (
                                                                <span className="download-button">
                                                                    <a href={this.fetchFile(video)} className="ds-video green">
                                                                        <img
                                                                            className="download_image"
                                                                            src={download_image}
                                                                        />{" "}
                                                                        Download
                                                                    </a>
                                                                </span>
                                                            )}
                                                            {video.video_downloadable == 0 && video.subscribed_to_play && (
                                                                <span className="purchase-download-button cursor-pointer" onClick={() => this.purchaseDownload(video)}>
                                                                    <a onClick={() => this.purchaseDownload(video)} className="ds-video orange">
                                                                        <img
                                                                            className="download_image"
                                                                            src={download_image}
                                                                        />{" "}
                                                                        Purchase Download
                                                                    </a>
                                                                </span>
                                                            )}

                                                            {!video.subscribed_to_play && (
                                                                <span className="purchase-download-button cursor-pointer" onClick={() => this.playVideo(video.video_url, video, false)}>
                                                                    <a onClick={() => this.playVideo(video.video_url, video, false)} className="ds-video orange">
                                                                        Subscribe
                                                                    </a>
                                                                </span>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                                {/* {this.state.videos_data.user_can_correct_videos && (
                                                <span className="">
                                                    <a className="ds-video orange">
                                                    <img
                                                        className="download_image"
                                                        src={download_image}
                                                    />{" "}
                                                    Edit
                                                    </a>
                                                </span>
                                                )} */}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="video_container ">
                                <div className="video-content">
                                    <div className="thumb-image">
                                        <img src={horse_logo} />
                                        <span className="float-left">No videos Found</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <Pagination
                        items={this.state.total_rows}
                        onChangePage={this.onChangePage}
                        initialPage={this.state.page}
                        pageSize={12}
                        ref={this.state.PaginationElement}
                    />
                    <div>
                        <span className="link_color"><b>Showing {((this.state.page - 1) * 12) + 1} to {(this.state.page - 1) * 12 + this.state.videos_count} of {this.state.total_rows} results.</b></span>
                        {this.state.pagination_wait ? <span id="pagination-wait" className=''>   <img src={indicator_icon} /></span> : null}
                    </div>
                </div>

                <div>
                    {/* {(this.state.playing_video) && */}
                    <VideoPlayer
                        is_open_play_video_modal={this.state.is_open_play_video_modal}
                        company_id={this.context.company_id}
                        is_open_do_subscription_modal={this.state.is_open_do_subscription_modal}
                        is_download_subscription={this.state.is_download_subscription}
                        video_to_play={this.state.video_to_play}
                        is_admin={this.state.is_admin}
                        closeModal={this.closePlayVideoModal}
                        closeSubscriptionModal={this.closeSubscriptionModal}
                        playing_preview={this.state.playing_preview}
                        play_video_path={(this.state.playing_preview) ? this.state.video_to_play.preview_url : this.state.video_to_play.video_url}
                        playVideoAfterSubscribe={this.playVideoAfterSubscribe}
                        VideoSubscriptionElement={this.VideoSubscriptionElement}
                    />
                    {/* } */}
                </div>
                <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
            </div>
        );
    }
}
Videos.contextType = SglContext;

export default Videos;
